module.exports = __webpack_public_path__ + "img/icon3.90db8961.svg";